import { $api } from 'api/http'
import { ICredentials, IPartnerProfile } from 'api/types/auth'
import { ICreateUser, IUser } from 'api/types/user'

class AuthApiService {
  setSignIn(credentials: ICredentials) {
    return $api.post<IUser>('/sign-in', credentials)
  }
  setSignUp(user: ICreateUser) {
    return $api.post<IUser>('/sign-up', user)
  }
  setPartnerProfile(profile: IPartnerProfile) {
    return $api.post<IPartnerProfile>('/reg_form', profile)
  }
}

export const authApiService = new AuthApiService()
